module.exports = __webpack_public_path__ + "static/media/PZAP-MATIC.7c5a3713.png";